export default __webpack_public_path__ + "static/media/portfolio.581d7e0d.png";